import { UrlConfig } from "@shared/config/url.config";

export class EntiteConfig {

  private static baseUrl = UrlConfig.urlEntreprise;

  private static entites: string = EntiteConfig.baseUrl + 'organismes-formation';
  private static contacts: string = EntiteConfig.baseUrl + 'contacts';

  public static get referentielEntiteURL(): string {
    return EntiteConfig.baseUrl;
  }

  public static get beneficiaireList(): string {
    return EntiteConfig.entites;
  }

  public static get contactsList(): string {
    return EntiteConfig.contacts;
  }
}
